<div class="container__fluid">
    <section id="content">
        <iframe id="iframe" [src]="url" (load)="onLoad()" allowfullscreen sandbox="allow-downloads allow-modals allow-scripts allow-forms allow-popups allow-same-origin allow-popups-to-escape-sandbox allow-presentation">
      </iframe>
    </section>
</div>